import { observable } from "@legendapp/state";

export const state$ = observable({
    affaires: {
        list: [],
        loading: false,
        pagination: null,
        filters: {
            searchText: null,
            statut: "pending",
            responsable_id: null,
            modele_id: null,
            etape_id: null,
            priorite_id: null,
            departement_id: null,
            date_from: null,
            date_to: null,
            created_from: null,
            created_to: null,
            my_role: null,
        }
    },
    mesAffaires: {
        list: [],
        loading: false,
        pagination: null,
        filters: {
            searchText: null,
            statut: "tout",
            modele_id: null,
            etape_id: null,
            priorite_id: null,
            showMines: true,
        }
    },
    taches: {
        list: [],
        loading: false,
        pagination: null,
        filters: {
            searchText: null,
            affaire_id: null,
            responsable_id: null,
            priorite_id: null,
            statut_id: null,
            departement_id: null,
            date_from: null,
            date_to: null,
            resolu: false,
            my_role: null,
        }
    },
    mesTaches: {
        list: [],
        loading: false,
        pagination: null,
        filters: {
            searchText: null,
            affaire_id: null,
            priorite_id: null,
            statut_id: null,
            showMines: true,
        }
    },
    activites: {
        list: [],
        loading: false,
        pagination: null,
        filters: {
            searchText: null,
            statut: "pending",
        }
    },
    mesActivites: {
        list: [],
        loading: false,
        pagination: null,
        filters: {
            searchText: null,
            showMines: true,
        }
    },
    // Cache partagé (chargé une seule fois) pour les sélecteurs de responsable
    // affichés en boucle dans les listes (évite un appel API par carte).
    usersDirectory: {
        list: [],
        loaded: false,
    },
    personnelsDirectory: {
        list: [],
        loaded: false,
    },
    // Other global states will be added here
});
